import { ItemService } from "~/services/public/ItemService"

export const state = (): ItemVehicle => ({
  categoryItems: {
    categoryId: null,
    list: null
  },
  make: {
    categoryId: null,
    list: null
  },
  model: {
    categoryId: null,
    makeId: null,
    list: null
  },
  vehicle: null,
  vehiclePlateNumber: null,
  itemId: null,
  parentItemId: null
})

export const GET_CATEGORY_ITEMS = "getCategoryItems"
export const GET_MAKE = "getMake"
export const GET_MODEL = "getModel"
export const GET_VEHICLE = "getVehicle"
export const GET_VEHICLE_PLATE_NUMBER = 'getVehiclePlateNumber'
export const GET_ITEM_ID = 'getItemId'
export const GET_PARENT_ITEM_ID = 'getParentItemId'

export const getters = {
  [GET_CATEGORY_ITEMS]: (state: ItemVehicle): ItemVehicleCategoryItems => state.categoryItems,
  [GET_MAKE]: (state: ItemVehicle): ItemVehicleMake => state.make,
  [GET_MODEL]: (state: ItemVehicle): ItemVehicleModel => state.model,
  [GET_VEHICLE]: (state: ItemVehicle): Item | null => state.vehicle,
  [GET_VEHICLE_PLATE_NUMBER]: (state: ItemVehicle): Item | null => state.vehiclePlateNumber,
  [GET_ITEM_ID]: (state: ItemVehicle): Item | null => state.itemId,
  [GET_PARENT_ITEM_ID]: (state: ItemVehicle): Item | null => state.parentItemId,
}

export const _SET_CATEGORY_ITEMS = "setCategoryItems"
export const _SET_MAKE = "setMake"
export const _SET_MODEL = "setModel"
export const _SET_VEHICLE = "setVehicle"
export const _SET_VEHICLE_PLATE_NUMBER ='setVehiclePlateNumber'
export const _SET_ITEM_ID ='setItemId'
export const _SET_PARENT_ITEM_ID ='setParentItemId'

export const mutations = {
  [_SET_CATEGORY_ITEMS](state: ItemVehicle, categoryItems: ItemVehicleCategoryItems) {
    state.categoryItems = categoryItems
  },
  [_SET_MAKE](state: ItemVehicle, make: ItemVehicleMake) {
    state.make = make
  },
  [_SET_MODEL](state: ItemVehicle, model: ItemVehicleModel) {
    state.model = model
  },
  [_SET_VEHICLE](state: ItemVehicle, vehicle: Item) {
    state.vehicle = vehicle
  },
  [_SET_VEHICLE_PLATE_NUMBER](state: ItemVehicle, vehiclePlateNumber: string | null) {
    state.vehiclePlateNumber = vehiclePlateNumber
  },
  [_SET_ITEM_ID](state: ItemVehicle, itemId: number | null) {
    state.itemId = itemId
  },
  [_SET_PARENT_ITEM_ID](state: ItemVehicle, parentItemId: number | null) {
    state.parentItemId = parentItemId
  },
}

export const LOAD_CATEGORY_ITEMS = "loadCategoryItems"
export const LOAD_MAKE = "loadMake"
export const LOAD_MODEL = "loadModel"
export const LOAD_VEHICLE = "loadVehicle"
export const LOAD_ITEM = "loadItem"
export const SET_VEHICLE = "setVehicle"
export const SET_VEHICLE_PLATE_NUMBER = "setVehiclePlateNumber"

export const actions = {
  async [LOAD_CATEGORY_ITEMS]({ state, commit }, {$axios, $config, queryParams, locale}) {
    if (queryParams.category_id && queryParams.category_id !== state.categoryItems.categoryId) {
      const itemService = new ItemService($axios, $config)
      const list = await itemService.getCategoryItems(queryParams, locale)

      if (list && list.length > 0) {
        commit(_SET_CATEGORY_ITEMS, {
          categoryId: queryParams.category_id,
          list,
        })
      }
    }
  },
  async [LOAD_MAKE]({ state, commit }, {$axios, $config, queryParams, locale}) {
    if (queryParams.category_id && queryParams.category_id !== state.make.categoryId) {
      const itemService = new ItemService($axios, $config)
      const list = await itemService.getSearchMakeList(queryParams, locale)

      if (list && list.length > 0) {
        commit(_SET_MAKE, {
          categoryId: queryParams.category_id,
          list,
        })
      }
    }
  },
  async [LOAD_MODEL]({ state, commit }, {$axios, $config, queryParams, locale}) {
    if (queryParams.category_id && queryParams.make_id &&
      (queryParams.category_id !== state.model.categoryId || queryParams.make_id !== state.model.makeId)) {
      const itemService = new ItemService($axios, $config)
      const list = await itemService.getSearchModelList(queryParams, locale)

      if (list && list.length > 0) {
        commit(_SET_MODEL, {
          categoryId: queryParams.category_id,
          makeId: queryParams.make_id,
          list,
        })
      }
    }
  },
  async [LOAD_VEHICLE]({ state, commit }, {$axios, $config, queryParams, locale}) {
    if (queryParams.plate_number && queryParams.plate_number !== state.vehiclePlateNumber) {
      const itemService = new ItemService($axios, $config)
      const item = await itemService.getVehicleData(queryParams, locale)

      if (item) {
        commit(_SET_VEHICLE, item)
        commit(_SET_VEHICLE_PLATE_NUMBER, queryParams.plate_number)
        commit(_SET_ITEM_ID, null)
        commit(_SET_PARENT_ITEM_ID, null)
      } else {
        commit(_SET_VEHICLE_PLATE_NUMBER, '')
      }
    }
  },
  async [LOAD_ITEM]({ state, commit }, {$axios, $config, queryParams, locale}) {
    if (queryParams.item_id && queryParams.item_id !== state.itemId) {
      const itemService = new ItemService($axios, $config)
      const item = await itemService.getItem(queryParams, locale)

      if (item) {
        commit(_SET_VEHICLE, item)
        commit(_SET_ITEM_ID, queryParams.item_id)
        commit(_SET_PARENT_ITEM_ID, null)
        commit(_SET_VEHICLE_PLATE_NUMBER, null)
      }
    }
  },
  [SET_VEHICLE]({ state, commit }, data: Item | null) {
    const itemId = data ? data.item_id : null
    commit(_SET_VEHICLE, data)
    commit(_SET_PARENT_ITEM_ID, itemId)
    commit(_SET_ITEM_ID, null)
    commit(_SET_VEHICLE_PLATE_NUMBER, null)
  },
  [SET_VEHICLE_PLATE_NUMBER]({ state, commit }, data) {
    commit(_SET_VEHICLE_PLATE_NUMBER, data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
